import { mapGetters, mapActions } from 'vuex';
import SummaryView from '@/helpers/summaryView';

export default {
	async mounted() {
		await this.fetchFinancers();
	},
	computed: {
		...mapGetters(['getCalculation']),
		...mapGetters('contracting', ['getSelectedOffer', 'getAllFormData', 'getFinancers']),
		optionsForName(index = 1) {
			return {
				label: 'Finanszírozó neve *',
				type: 'searchSelect',
				className: '',
				wrapperClass: 'px-5px',
				inputClass: 'w-50 mobile-width-full',
				tooltip: false,
				rules: {
					required: true,
				},
				choices: this.getFinancers,
				mask: '',
				inputmode: 'text',
				input: {
					parent: 'financingData',
					group: 'creditorDetails',
					prop: 'name',
				},
				refGroup: `financingData-insuredsData-${index}`,
				field: {
					value: 'ws_id',
					text: 'long_name',
				},
			};
		},
		computedFinancingFields() {
			return (index, group) => {
				return _.mapValues(this.fields[group], financingData => {
					return {
						...financingData,
						refGroup: `financingData-${group}-${index}`,
					};
				});
			};
		},
	},
	methods: {
		...mapActions('contracting', ['fetchFinancers', 'saveNew']),
		makeFinancersChoices() {
			let results = {};

			_.each(this.getFinancers, financer => {
				_.assign(results, { [financer.ws_id]: financer.long_name });
			});

			return results;
		},
		handleClick(value, index = 1) {
			const selectedFinancer = _.find(this.getFinancers, financer => financer.ws_id === parseInt(value));

			const setFields = [
				'postal_code',
				'city',
				'address_name',
				'address_type',
				'from_house_number',
				'to_house_number',
				'floor',
				'door',
			];

			_.each(setFields, field => {
				this.handleSetData(field, selectedFinancer[field], true, index);
			});

			this.handleSetData('ws_id', selectedFinancer.ws_id, false, index);
		},
		handleSetData(prop, value, validate = true, index = 1) {
			this.setFormData({
				parent: 'financingData',
				group: 'creditorDetails',
				prop: prop,
				value: value,
				index,
			});

			if (validate) {
				this.$refs[`${prop}-${index}`][0].$refs.component.$refs.provider.validate(value);
			}
		},
		beforeNext() {
			return new Promise(async (resolve, reject) => {
				const summaryView = new SummaryView(
					this.getCalculation,
					this.getSelectedOffer,
					this.getAllFormData,
					this.$store,
				);

				const saved = await this.saveNew({ dataKey: 'financingData', summaryView: summaryView.getData() });

				if (saved) {
					resolve({ success: true, routeTo: 'contracting-summary' });
				}
			});
		},
		beforePrev() {
			return new Promise((resolve, reject) => {
				if (this.getCheckboxData('differentInsuredData')) {
					resolve({ success: true, routeTo: 'contracting-insured' });
				}

				resolve({ success: true, routeTo: 'contracting-base' });
			});
		},
	},
};
